import { api } from '../../../api/axios'
import type { Modalidade, ModalidadeFilters, RegraDesempate } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const modalidadesService = {
  list: (filters: ModalidadeFilters = {}) =>
    api.get<ListResponse<Modalidade>>('/modalidades', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Modalidade }>(`/modalidades/${id}`).then(r => r.data.data),

  create: (data: Omit<Modalidade, 'idmodalidade' | 'campeonato_descricao'>) =>
    api.post<{ data: Modalidade }>('/modalidades', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Modalidade, 'idmodalidade' | 'campeonato_descricao'>>) =>
    api.put<{ data: Modalidade }>(`/modalidades/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/modalidades/${id}`),

  listRegras: (idmodalidade: number) =>
    api.get<{ data: RegraDesempate[] }>(`/modalidades/${idmodalidade}/regras-desempate`).then(r => r.data.data),

  aplicarPadrao: (idmodalidade: number) =>
    api.post<{ data: RegraDesempate[] }>(`/modalidades/${idmodalidade}/regras-desempate/padrao`).then(r => r.data.data),

  createRegra: (idmodalidade: number, data: Omit<RegraDesempate, 'idregra_desempate' | 'idmodalidade'>) =>
    api.post<{ data: RegraDesempate }>(`/modalidades/${idmodalidade}/regras-desempate`, data).then(r => r.data.data),

  deleteRegra: (id: number) =>
    api.delete(`/regras-desempate/${id}`),
}
